/*=========================================================================================
  File Name: moduleCalendarMutations.js
  Description: Calendar Module Mutations
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

export default {
  SET_COURSE_STUDENT_FREEZING_LIST(state, data) {
    state.list = data.items;
    if (data && data.pagination) {
      state.pagination = { ...state.pagination, ...data.pagination };
    }
  },
  ADD_COURSE_STUDENT_FREEZING(state, data) {
    state.list.unshift(data);
  },
  UPDATE_COURSE_STUDENT_FREEZING(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.list.splice(pos, 1, data);
  },
  UPDATE_STATUS_FREEZING(state, data) {
    const pos = state.list
      .map(function (e) {
        return e.id;
      })
      .indexOf(data.id);
    state.list.splice(pos, 1, data);
  },
  SET_CURRENT_PAGE(state, data) {
    state.pagination.current_page = data;
  },
  SET_PER_PAGE(state, data) {
    state.pagination.per_page = data;
  },
};
